import React from 'react';
import PropTypes from 'prop-types';

import OutputText from '@ey/canvascoreservices/OutputText';

import {labels} from '../../../../util/utils';

import DashboardCheck from '../DashboardCheck';
import StyledDashboardCount from './StyledDashboardCount';

const DashBoardCount = (props) => {
	const {condition, count} = props;
	const text = count + ' ' + labels.dashboardViews;

	return (
		<StyledDashboardCount>
			<DashboardCheck condition={condition} />
			{count !== 0 && (
				<OutputText body2 light ellipsis title={text}>
					{text}
				</OutputText>
			)}
		</StyledDashboardCount>
	);
};

DashBoardCount.defaultProps = {};

DashBoardCount.propTypes = {
	condition: PropTypes.bool.isRequired
};

export default DashBoardCount;
